import React from "react";
import { Dialog } from "@/components/ui";
import { Fan } from "@/services/bedrock";
import { FanCreationForm } from "@/components/Forms/FanCreationForm";
import { getFanFormDefaultValues } from "@/utils/fanHelpers";

interface FanDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedFan: Fan | null;
  onFormSubmit: (formData: any) => void;
  isSubmitting: boolean;
  isPlayerContext?: boolean;
}

export function FanDialog({
  open,
  onOpenChange,
  selectedFan,
  onFormSubmit,
  isSubmitting,
  isPlayerContext = false,
}: FanDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange} size="lg">
      <Dialog.Header>
        <Dialog.Title>{selectedFan ? "Edit Contact" : "Create New Contact"}</Dialog.Title>
        <Dialog.Description>
          {selectedFan ? "Update contact details and preferences." : "Add a new client contact to your list."}
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.Content className="max-h-[70vh] overflow-y-auto py-4">
        <FanCreationForm
          onSubmit={onFormSubmit}
          isSubmitting={isSubmitting}
          hidePlayerSelect={isPlayerContext}
          submitLabel={selectedFan ? "Save Contact" : "Create Contact"}
          defaultValues={getFanFormDefaultValues(selectedFan)}
        />
      </Dialog.Content>
    </Dialog>
  );
}
